<template>
  <div>
    <v-row>
      <v-col>
        <div v-if="nodesAreHidden" class="text-body-1 text-center">
          [No matches found]
        </div>
        <v-treeview
          v-if="treeViewRecord"
          :key="treeViewKey"
          ref="treeView"
          v-model="selectedNodes"
          :selection-type="selectionType"
          :selectable="isSelectedable"
          return-object
          :items="[treeViewRecord] || this.previouslyopenednodes"
          :open="openIds"
          item-key="_id"
          item-text="name"
          class="treeClass"
          dense
          :open-on-click="true"
          :search="treeFilter"
        >
          <template v-slot:append="{ item }">
            <v-row class="treerow">
              <Menu
                :parentID="item._id"
                :node="item"
                :selectedRecord="selectedRecord"
              ></Menu>
            </v-row>
          </template>
          <template v-slot:label="{ item }">
            <div class="text-truncate">{{ item.name }}</div>
            <div v-if="hasScore(item._id)" class="text-subtitle-2 ml-3">
              (Score: {{ getScore(item._id) }})
            </div>
          </template>
        </v-treeview>
        <span v-else>
          <div class="text-center">Loading record...</div>
          <v-progress-linear
            class="progress-bar"
            indeterminate
            color="primary"
          ></v-progress-linear>
        </span>
      </v-col>
    </v-row>
    <div
      class="section-container"
      v-if="treeViewRecord && CurrentlySelectedAccount"
    >
      <div class="d-flex justify-space-between align-center">
        <div class="body-1 mb-2 d-flex flex-row">
          <v-btn
            small
            text
            class="body-2 pl-1"
            @click.stop="expandedSectionOrders = !expandedSectionOrders"
          >
            <v-icon :class="{ open: expandedSectionOrders }">
              mdi-menu-right
            </v-icon>
            <span class="body-1 section-header">Orders</span>
          </v-btn>
        </div>
        <div>
          <span>
            <v-tooltip max-width="30vw" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" @click.stop="viewTimeline">
                  <v-icon small>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>View Order Timeline</span>
            </v-tooltip>
            <v-dialog
              v-if="showOrdersTimeline"
              v-model="showOrdersTimeline"
              width="600px"
            >
              <orderTimeline :orders="treeViewRecord.orders" />
            </v-dialog>
          </span>
          <span>
            <v-tooltip max-width="30vw" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="addOrder"
                  :disabled="showAddOrder"
                >
                  <v-icon small>mdi-plus-thick</v-icon>
                </v-btn>
              </template>
              <span>Create new order</span>
            </v-tooltip>
            <v-dialog
              v-if="showAddOrder"
              v-model="showAddOrder"
              width="600px"
              persistent
            >
              <AddEditOrder
                :selectedRecord="selectedRecord"
                :tree="treeViewRecord"
                :events="events"
                :editMode="editOrderMode"
                :existingOrder="existingOrder"
                :openNotifications="openNotifications"
                @cancel-add-dialog="showAddOrder = !showAddOrder"
                @close-add-dialog="showAddOrder = !showAddOrder"
              ></AddEditOrder>
            </v-dialog>
          </span>
        </div>
      </div>
      <v-divider></v-divider>
      <span v-if="expandedSectionOrders">
        <div
          class="ml-5 mt-2"
          v-for="order in treeViewRecord.orders"
          :key="order._id"
        >
          <div class="section">
            <v-btn
              small
              text
              @click.stop="toggleExpanded('expandedOrders', order._id)"
              class="body-2"
            >
              <v-icon :class="{ open: expandedOrders[order._id] }">
                mdi-menu-right
              </v-icon>
              <span>
                {{ order.name }}
                <v-icon v-if="order.state !== 'active'" small>mdi-sleep</v-icon>
              </span>
            </v-btn>
            <span>
              <v-tooltip max-width="30vw" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="editOrder(order, false)"
                  >
                    <v-icon small>mdi-cog</v-icon>
                  </v-btn>
                </template>
                <span>Change this Order</span>
              </v-tooltip>
              <v-tooltip max-width="30vw" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="deleteOrder(order)"
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Remove this Order</span>
              </v-tooltip>
            </span>
          </div>
          <transition name="fade">
            <div v-if="expandedOrders[order._id]">
              <div class="ml-10">
                <div>
                  Created on {{ formatJustDatestamp(order.created_at) }}
                </div>
                <div>Frequency: {{ getFrequencyString(order) }}</div>
                <div>{{ getExpiry(order.duration) }}</div>
                <div>
                  Using event
                  <a href="#" @click.stop="viewEvent(order.event)">
                    {{ order.event }}
                  </a>
                </div>
                <div>
                  <a href="#" @click.stop="editOrder(order, true)">
                    {{ listNotifications(order.notifications) }}
                  </a>
                </div>
                <div>{{ order.state === "active" ? "Active" : "Paused" }}</div>
              </div>
            </div>
          </transition>
        </div>
      </span>
    </div>
    <div class="section-container">
      <div class="d-flex justify-space-between align-center">
        <div class="body-1 mb-2 d-flex flex-row">
          <v-btn
            small
            text
            class="body-2 pl-1"
            @click.stop="expandedSectionEvents = !expandedSectionEvents"
          >
            <v-icon :class="{ open: expandedSectionEvents }">
              mdi-menu-right
            </v-icon>
            <span class="body-1 section-header">Events</span>
          </v-btn>
        </div>
        <span>
          <v-tooltip max-width="30vw" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                @click.stop="showAddEvent = true"
                :disabled="isSelectedable"
              >
                <v-icon small>mdi-clipboard-edit-outline</v-icon>
              </v-btn>
            </template>
            <span>Create new event via a dialog</span>
          </v-tooltip>
          <v-tooltip max-width="30vw" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click.stop="toggleAddEvent">
                <v-icon small>mdi-plus-thick</v-icon>
              </v-btn>
            </template>
            <span>Create new event using the tree</span>
          </v-tooltip>
          <v-dialog
            v-if="showAddEvent"
            v-model="showAddEvent"
            width="600px"
            persistent
          >
            <AddEvent
              :tree="treeViewRecord"
              :selectedRecord="selectedRecord"
              @cancel-add-dialog="showAddEvent = !showAddEvent"
              @close-add-dialog="showAddEvent = !showAddEvent"
            ></AddEvent>
          </v-dialog>
        </span>
      </div>
      <div
        v-if="showAddEvent1"
        class="d-flex justify-space-between align-center mb-2"
      >
        <v-text-field
          class="mx-3"
          label="Event name"
          v-model="eventName"
          hint="Select categories from the tree above to add to this Event."
          required
          :rules="[() => !!eventName || 'An Event name is required']"
        ></v-text-field>
        <v-btn
          x-small
          class="mr-2"
          color="primary"
          @click.stop="createEvent"
          :disabled="eventName === ''"
        >
          Create
        </v-btn>
        <v-btn
          x-small
          outlined
          class="mr-2"
          color="secondary"
          @click.stop="cancelAddEvent"
        >
          Cancel
        </v-btn>
      </div>
      <v-divider></v-divider>
      <span v-if="expandedSectionEvents">
        <div
          class="ml-5 mt-2"
          v-for="[key, value] in Object.entries(events)"
          :key="key"
        >
          <div class="section">
            <v-btn
              small
              text
              @click.stop="toggleExpanded('expandedEvents', key)"
              class="body-2"
            >
              <v-icon :class="{ open: expandedEvents[key] }">
                mdi-menu-right
              </v-icon>
              <span>{{ key }}</span>
            </v-btn>
            <span>
              <v-tooltip max-width="30vw" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="viewEvent(key)"
                  >
                    <v-icon small>mdi-eye</v-icon>
                  </v-btn>
                </template>
                <span>Show this Event</span>
              </v-tooltip>
              <v-tooltip max-width="30vw" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="
                      addDataToEvent(key, currentRecordDateTimeStamp)
                    "
                  >
                    <v-icon small>mdi-pencil-plus</v-icon>
                  </v-btn>
                </template>
                <span>Add data to this Event</span>
              </v-tooltip>
              <v-tooltip max-width="30vw" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="openDateTimeDialog(key)"
                  >
                    <v-icon small>mdi-calendar-plus</v-icon>
                  </v-btn>
                </template>
                <span>Add data at a specific date/time to this Event</span>
              </v-tooltip>
              <v-tooltip max-width="30vw" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="openRenameEvent(key)"
                  >
                    <v-icon small>mdi-cog</v-icon>
                  </v-btn>
                </template>
                <span>Rename this Event</span>
              </v-tooltip>
              <v-tooltip max-width="30vw" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="deleteEvent(key)"
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Remove this Event</span>
              </v-tooltip>
            </span>
          </div>
          <div v-if="showEventRename === key" class="ml-9">
            <div class="d-flex justify-space-between align-center mb-2 mt-0">
              <v-text-field
                class="mr-3"
                label="Event name"
                v-model="newEventName"
                required
                :rules="[() => !!newEventName || 'An Event name is required']"
              ></v-text-field>
              <v-btn
                x-small
                class="mr-2"
                color="primary"
                @click.stop="renameEvent(key, newEventName)"
                :disabled="newEventName === '' || renameInProgress"
              >
                <span>{{ renameInProgress ? "Renaming..." : "Rename" }}</span>
              </v-btn>
              <v-btn
                x-small
                outlined
                class="mr-2"
                color="secondary"
                @click.stop="cancelRenameEvent"
              >
                Cancel
              </v-btn>
            </div>
          </div>
          <transition name="fade">
            <div v-if="expandedEvents[key]">
              <div v-for="(node, index) in value" :key="index">
                <div class="ml-10 py-1 cat-name" :key="`${key}-${node.name}`">
                  {{ node.name }}
                </div>
              </div>
            </div>
          </transition>
          <v-dialog
            v-if="showDateTimeDialog"
            v-model="showDateTimeDialog"
            width="600px"
            persistent
          >
            <div class="d-flex flex-row menu-background">
              <div class="d-flow flow-column">
                <v-date-picker
                  v-model="pickerDate"
                  no-title
                  scrollable
                  show-adjacent-months
                  :max="today"
                ></v-date-picker>
                <div class="text-center">
                  <v-btn
                    text
                    color="secondary"
                    @click="showDateTimeDialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="addValuesFromDatepicker(pickerDate, pickerTime)"
                  >
                    OK
                  </v-btn>
                </div>
              </div>
              <v-spacer></v-spacer>
              <v-time-picker
                v-model="pickerTime"
                scrollable
                ampm-in-title
                format="ampm"
                :allowed-minutes="[0, 15, 30, 45]"
              ></v-time-picker>
            </div>
          </v-dialog>
        </div>
      </span>
    </div>
    <div class="section-container">
      <div class="d-flex justify-space-between align-center">
        <div class="body-1 mb-2 d-flex flex-row">
          <v-btn
            small
            text
            class="body-2 pl-1"
            @click.stop="expandedSectionViews = !expandedSectionViews"
          >
            <v-icon :class="{ open: expandedSectionViews }">
              mdi-menu-right
            </v-icon>
            <span class="body-1 section-header">Views</span>
          </v-btn>
        </div>
        <v-tooltip max-width="30vw" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click.stop="toggleAddGroup"
              :disabled="isSelectedable"
            >
              <v-icon small>mdi-plus-thick</v-icon>
            </v-btn>
          </template>
          <span>Create new view</span>
        </v-tooltip>
      </div>
      <div
        v-if="showAddGroup"
        class="d-flex justify-space-between align-center mb-2"
      >
        <v-text-field
          class="mx-3"
          label="View name"
          v-model="groupName"
          hint="Select categories from the tree above to add to this View."
          required
          :rules="[() => !!groupName || 'An entry is required']"
        ></v-text-field>
        <v-btn
          x-small
          class="mr-2"
          color="primary"
          @click.stop="createGroup"
          :disabled="groupName === ''"
        >
          Create
        </v-btn>
        <v-btn
          x-small
          outlined
          class="mr-2"
          color="secondary"
          @click.stop="cancelAddGroup"
        >
          Cancel
        </v-btn>
      </div>
      <v-divider></v-divider>
      <span v-if="expandedSectionViews">
        <div
          class="ml-5 mt-2"
          v-for="[key, value] in Object.entries(groups)"
          :key="key"
        >
          <div class="section">
            <v-btn
              small
              text
              @click.stop="toggleExpanded('expandedGroups', key)"
              class="body-2"
            >
              <v-icon :class="{ open: expandedGroups[key] }">
                mdi-menu-right
              </v-icon>
              <span>{{ key }}</span>
            </v-btn>
            <span>
              <v-tooltip max-width="30vw" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="viewGroup(key)"
                  >
                    <v-icon small>mdi-eye</v-icon>
                  </v-btn>
                </template>
                <span>Show this view</span>
              </v-tooltip>
              <v-tooltip max-width="30vw" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="deleteGroup(key)"
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Remove this View</span>
              </v-tooltip>
            </span>
          </div>
          <transition name="fade">
            <div v-if="expandedGroups[key]">
              <div v-for="(node, index) in value" :key="index">
                <div class="ml-10 py-1 cat-name" :key="`${key}-${node.name}`">
                  {{ node.name }}
                </div>
              </div>
            </div>
          </transition>
        </div>
      </span>
    </div>
    <div class="section-container">
      <div class="body-1 ml-3 mb-2">Analysis</div>
      <v-divider></v-divider>
      <div class="ml-5 mt-2">
        <!--
        <div v-if="!analysisReady">

          <div v-if="analysisError" class="section">
            <p class="font-weight-medium">
              Unable to analyze records. Error is
              <span class="error">{{ analysisErrorText }}</span>
            </p>
          </div>
          <div v-else class="section">
            <p>Analyzing similar records…</p>
            <v-progress-circular
              class="mr-3 mb-4"
              indeterminate
              :size="18"
              :width="1"
              color="secondary"
            ></v-progress-circular>
          </div>

        </div>
        <div v-else>
          <div class="section">
            <div>
              <span>Similarity Coefficent</span>

            </div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="viewAnalysis()"
                  :disabled="!analysisCats.length"
                >

                  <v-icon small>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>Show the analysis</span>
            </v-tooltip>

          </div>
          <v-slider
            v-model="sampleSize"
            :step="sampleStep"
            :min="sampleMin"
            :max="sampleMax"
            ticks="always"
            tick-size="4"
            hint="The smaller the Similarity Coefficient, the more similar the other records must be to be inclused in the analysis. Note that this might mean no results will be returned."
            :tick-labels="tickLabels"
            class="ml-0 mr-2 range-slider"
          ></v-slider>
          <v-autocomplete
            v-model="analysisCats"
            :items="allCDGCats"
            auto-select-first
            clearable
            multiple
            class="white--text mr-2"
            item-color="#78909c"
            label="Factors"
            hide-selected
            clear-icon="mdi-close-circle"
            hint="A list of factors to be analyzed against similar records."
            @change="updateAnalysisCats($event)"
            :search-input.sync="search"
          >
            <template v-slot:selection="{ attr, on, item, index, selected }">
              <v-chip
                v-bind="attr"
                :input-value="selected"
                color="#78909c"
                class="white--text"
                small
                v-on="on"
                close
                @click:close="removeAnalysisCat(index)"
              >
                <span v-text="item"></span>
              </v-chip>
            </template>
          </v-autocomplete>
        </div>
	-->
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions, mapState } from "vuex";
import { strings } from "vuex-store-builder";
import { deleteOrderById } from "../../utils/api.js";
import {
  treePeriodicAdderForEventNodes,
  treeWalker,
} from "../../utils/treeUtils";
import moment from "moment";

import Menu from "./Menu";
import AddEvent from "./record-viewer/AddEvent";
import AddEditOrder from "./record-viewer/AddEditOrder";
import orderTimeline from "./orders/Timeline.vue";

export default {
  name: "FormBuilder",
  components: {
    Menu,
    AddEvent,
    AddEditOrder,
    orderTimeline,
  },
  props: {
    editMode: Boolean,
    tabIndex: Number,
    treeFilter: String,
    selectedRecord: Object,
  },
  data: function() {
    return {
      expandedGroups: [],
      expandedEvents: [],
      expandedOrders: [],
      expandedSectionViews: false,
      expandedSectionEvents: false,
      expandedSectionOrders: false,
      analysisCats: [],
      search: "",
      sampleSize: 3,
      sampleMin: 1,
      sampleStep: 1,
      sampleMax: 5,
      tickLabels: ["High", "", "Medium", "", "Low"],
      sampleSizeText: [
        "",
        "High",
        "Medium High",
        "Medium",
        "Medium Low",
        "Low",
      ],
      isSelectedable: false,
      treeViewKey: 0,
      selectedNodes: [],
      eventName: "",
      groupName: "",
      selectionType: "leaf",
      showAddEvent: false,
      showAddEvent1: false,
      showEventRename: "",
      renameInProgress: false,
      newEventName: "",
      showAddGroup: false,
      showAddOrder: false,
      showOrdersTimeline: false,
      nodesAreHidden: false,
      editOrderMode: false,
      existingOrder: {},
      openNotifications: false,
      showDateTimeDialog: false,
      pickerDate: null,
      pickerTime: null,
      today: new Date().toISOString(),
      openednodes: [],
      previouslyopenednodesid: [],
      previouslyopenednodes: [],
    };
  },
  mounted() {
    this.$root.$on("analysis:add", (node) => {
      this.$store.commit("ADD_NODE_TO_ANALYSIS_GROUP", {
        group: "default",
        node: node,
        recordId: this.selectedRecord._id || this.selectedRecord._id,
      });
    });
    this.$root.$on("analysis:remove", (node) => {
      this.$store.commit("REMOVE_NODE_FROM_ANALYSIS_GROUP", {
        group: "default",
        node: node,
        recordId: this.selectedRecord._id || this.selectedRecord._id,
      });
    });
  },
  created() {
    // this.eventz = this.selectedRecord.meta.events;
  },
  updated() {
    // this.eventz = this.events || this.selectedRecord.meta.events;
    setInterval(() => {
      if (this.$refs.treeView) {
        this.previouslyopenednodesid = [...this.$refs.treeView.openCache];
      }
    }, 3000);
  },
  beforeDestroy() {
    clearInterval();
  },
  computed: {
    ...mapState({
      conditionallyHiddenNodes: (state) =>
        state.records.conditionallyHiddenRecordItemIds,
      currentRecordDateTimeStamp: (state) =>
        state.records.currentRecordDateTimeStamp,
    }),
    ...mapState("cdgGetStateId", {
      // analysisReady: strings.loaded("getStateId"),
      // analysisError: strings.errored('getStateId'),
      analysisError: "failed",
      analysisErrorText: "failedError",
      stateId: (state) => state.stateId,
    }),
    ...mapGetters({
      groups: "getGroupByRecord",
      events: "getEventsGroupByRecord",
      treeViewRecord: "getActiveRecord",
      getScore: "getScoreByNodeID",
      hasScore: "doesScoreExist",
      CurrentlySelectedAccount: "getCurrentlySelectedAccount",
    }),
    // ...mapGetters("cdgGetAnalysisCats", { allCDGCats: "list" }),
    ...mapGetters("allOrdersFromRecord", { orders: "list" }),

    showRecordItem: function() {
      for (let id of this.conditionallyHiddenNodes) {
        if (id == this.RecordItem._id) {
          return false;
        }
      }
      return true;
    },
    openIds() {
      if (this.previouslyopenednodes.length > 0) {
        return this.previouslyopenednodes;
      }
      return [this.treeViewRecord];
    },
  },
  methods: {
    ...mapActions([
      "updateRecordParentIdAndChildCount",
      "openNewTab",
      "getRecordItemOnDemand",
      "updateRecordFromDB",
    ]),

    viewGroup(group) {
      const fakeRecordItem = {
        name: `View ${group}`,
        _id: this.selectedRecord._id,
      };

      this.openNewTab({
        recordItem: fakeRecordItem,
        fullRecord: this.selectedRecord,
        type: "group",
        datetime: null,
        typeSpecificPayload: group,
      });
    },
    deleteGroup(group) {
      if (!window.confirm(`Are you sure you want to remove ${group}?`)) {
        return;
      }
      // Remove this group name from all the selected nodes
      this.groups[group].forEach((item) => {
        if (Array.isArray(item.meta.periodic_group)) {
          const index = item.meta.periodic_group.indexOf(group);
          if (index !== -1) {
            item.meta.periodic_group.splice(index, 1);
          }
        } else {
          item.meta.periodic_group = [];
        }
        this.updateNode(item, this.selectedRecord._id);
      });
      this.$store.dispatch("deleteGroup", {
        group,
        recordId: this.selectedRecord._id,
      });
    },
    viewEvent(event) {
      this.cancelRenameEvent();
      const fakeRecordItem = {
        name: `Event ${event}`,

        _id: this.selectedRecord._id,
      };
      this.openNewTab({
        recordItem: fakeRecordItem,
        fullRecord: this.selectedRecord,
        type: "event",
        datetime: this.currentRecordDateTimeStamp,
        typeSpecificPayload: event,
      });
    },
    async addDataToEvent(key, timestamp = this.currentRecordDateTimeStamp) {
      this.cancelRenameEvent();
      await this.viewEvent(key);
      this.$root.$emit("menu:edit-record", true, timestamp);
      this.addNewDataToAllEventNodes(key, timestamp);
    },
    addNewDataToAllEventNodes(eventkey, timestamp) {
      treePeriodicAdderForEventNodes(this.selectedRecord, timestamp, eventkey);
    },
    addValuesFromDatepicker(date, time) {
      const datePieces = date.split("-");
      const timePeices = time.split(":");
      // We have to build the date and time in pieces since otherwise it will default to UTC
      const timestamp = new Date(
        datePieces[0],
        datePieces[1] - 1,
        datePieces[2],
        timePeices[0],
        timePeices[1]
      );
      this.addDataToEvent(this.showDateTimeDialog, timestamp.toISOString());
      this.showDateTimeDialog = false;
    },
    openDateTimeDialog(key) {
      // This is a bit cheesy as normally this would be a true/false. But since a string is "truthy", it is
      // a way to pass the event name to addValuesFromDatepicker
      this.showDateTimeDialog = key;
    },
    // getEventNodes(recordid) {
    //   let eventNodes = [];
    //   const foundNode = treeWalker(recordid, node._id);
    //   this.eventNodes.push(foundNode);
    //   const parent = foundNode.parent;
    //   if (parent) {
    //     if (this.nodeGroups[parent]) {
    //       const children = this.nodeGroups[parent];
    //       children.push(foundNode);
    //       this.$set(this.nodeGroups, parent, children);
    //     } else {
    //       this.$set(this.nodeGroups, parent, [foundNode]);
    //     }
    //   }
    // },
    updateAnalysisCats(e) {
      this.$store.commit("UPDATE_ANALYSIS_GROUP", {
        group: "default",
        members: e,
        recordId: this.selectedRecord._id,
      });
      this.search = "";
    },
    removeAnalysisCat(index) {
      this.$store.commit("REMOVE_NODE_FROM_ANALYSIS_GROUP", {
        group: "default",
        node: this.analysisCats[index],
        recordId: this.selectedRecord._id,
      });
    },

    viewAnalysis() {
      // Save factors for this id
      this.updateAnalysisCats(this.analysisCats);
      // kick off the analysis
      let payload = {
        state_id: this.stateId,
        categories: this.analysisCats,
        sample_size: this.sampleSize,
      };
      this.$store.dispatch("cdgFetchCommonalities/fetchCommonalities", payload);
      const fakeRecordItem = {
        text: `Analysis - ${this.sampleSizeText[this.sampleSize]} Similarity`,
        _id: this.selectedRecord._id,
      };
      payload = {
        stateId: this.stateId,
        sampleSize: this.sampleSize,
        group: "default",
      };
      this.openNewTab({
        recordItem: fakeRecordItem,
        fullRecord: this.selectedRecord,
        type: "analysis",
        datetime: null,
        typeSpecificPayload: payload,
      });
    },

    toggleExpanded(param, group) {
      if (this[param][group]) {
        this[param][group] = !this[param][group];
      } else {
        this.$set(this[param], group, true);
      }
    },
    async createEvent() {
      this.cancelRenameEvent();
      // Put up an "Are you sure?" dialog of some sort
      if (
        this.events[this.eventName] &&
        !window.confirm(
          `${this.eventName} already exists. Are you sure you want to replace it?`
        )
      ) {
        return;
      }

      this.isSelectedable = false;
      this.showAddEvent1 = false;
      // Work around an issue with the Vtree where it doesn't return
      // All the selected nodes. So search the components list of
      // nodes and build our own array filtering out title nodes
      const totalSelectedNodes = Object.values(this.$refs.treeView.nodes)
        .filter((node) => node.isSelected && node.item.meta.type !== "title")
        .map((node) => node.item);
      // Add this event name to all the selected nodes
      const promises = totalSelectedNodes.map(async (item) => {
        if (Array.isArray(item.meta.events)) {
          const index = item.meta.events.indexOf(this.eventName);
          if (index === -1) {
            // Only add the event if it isn't already there
            item.meta.events.push(this.eventName);
          }
        } else {
          item.meta.events = [this.eventName];
        }
        let root_id = this.selectedRecord._id || this.selectedRecord._id;

        return this.updateNode(item, root_id);
      });

      // Make sure all the updates have completed and refetch the record from the server
      await Promise.all(promises);
      this.updateRecordFromDB(this.selectedRecord._id);

      this.selectedNodes = [];
      this.eventName = "";
    },
    async createGroup() {
      // Put up an "Are you sure?" dialog of some sort
      if (
        this.groups[this.groupName] &&
        !window.confirm(
          `${this.groupName} already exists. Are you sure you want to replace it?`
        )
      ) {
        return;
      }
      this.isSelectedable = false;
      this.showAddGroup = false;
      // Work around an issue with the Vtree where it doesn't return
      // All the selected nodes. So search the components list of
      // nodes and build our own array filtering out title nodes
      const totalSelectedNodes = Object.values(this.$refs.treeView.nodes)
        .filter((node) => node.isSelected && node.item.meta.type !== "title")
        .map((node) => node.item);
      // Add this group name to all the selected nodes
      const promises = totalSelectedNodes.map(async (item) => {
        if (Array.isArray(item.meta.periodic_group)) {
          const index = item.meta.periodic_group.indexOf(this.groupName);
          if (index === -1) {
            // Only add the group if it isn't already there
            item.meta.periodic_group.push(this.groupName);
          }
        } else {
          item.meta.periodic_group = [this.groupName];
        }
        let root_id = this.selectedRecord._id || this.selectedRecord._id;
        return this.updateNode(item, root_id);
      });

      // Make sure all the updates have completed and refetch the record from the server
      await Promise.all(promises);
      this.updateRecordFromDB(this.selectedRecord._id);

      this.selectedNodes = [];
      this.groupName = "";
    },
    async deleteEvent(event) {
      //check if event is part of an active order
      const theRecord = this.$store.state.records.selectedRecords[
        this.$store.state.records.selectedRecords.length - 1
      ];
      if (
        theRecord.orders?.some((order) => order.event === event && order.active)
      ) {
        return window.alert(
          `${event} cannot be removed because it is part of an active order`
        );
      }
      if (!window.confirm(`Are you sure you want to remove ${event}?`)) {
        return;
      }
      // Remove this event name from all the selected nodes
      const promises = this.events[event].map((item) => {
        if (Array.isArray(item.meta.events)) {
          const index = item.meta.events.indexOf(event);
          if (index !== -1) {
            item.meta.events.splice(index, 1);
          }
        } else {
          item.meta.events = [];
        }
        return this.updateNode(item, this.selectedRecord._id);
      });
      await Promise.all(promises);
      this.$store.dispatch("deleteEvent", {
        event,
        recordId: this.selectedRecord._id,
      });
    },
    async renameEvent(event, newName) {
      if (this.events[newName]) {
        window.alert(
          `Event ${newName} already exists. Please choose another name.`
        );
        return;
      }
      this.renameInProgress = true;
      // Rename this event name in all nodes
      const promises = this.events[event].map((item) => {
        if (Array.isArray(item.meta.events)) {
          const index = item.meta.events.indexOf(event);
          // console.log(item.name, newName, index, item.meta.events)
          if (index !== -1) {
            item.meta.events.splice(index, 1, newName);
            return this.updateNode(item, this.selectedRecord._id);
          }
        }
      });
      await Promise.all(promises);
      this.$store.dispatch("renameEvent", {
        event,
        newName,
        recordId: this.selectedRecord._id,
      });
      this.renameInProgress = false;
      this.cancelRenameEvent();
    },
    async updateNode(obj, root_id) {
      const payload = {
        obj,
        root_id,
      };

      return this.$store.dispatch("updateRecNode/updateRecordNode", payload);
    },
    cancelAddEvent() {
      this.showAddEvent1 = false;
      this.isSelectedable = false;
      this.eventName = "";
      this.selectedNodes = [];
    },
    toggleAddEvent() {
      this.showAddEvent1 = !this.showAddEvent1;
      this.isSelectedable = !this.isSelectedable;
    },
    cancelAddGroup() {
      this.showAddGroup = false;
      this.isSelectedable = false;
      this.GroupName = "";
      this.selectedNodes = [];
    },
    openRenameEvent(event) {
      this.showEventRename = event;
      this.newEventName = event;
    },
    cancelRenameEvent() {
      this.showEventRename = "";
      this.newEventName = "";
    },
    toggleAddGroup() {
      this.showAddGroup = !this.showAddGroup;
      this.isSelectedable = true;
    },
    editOrder(order, autoOpen) {
      this.showAddOrder = true;
      this.editOrderMode = true;
      this.existingOrder = order;
      this.openNotifications = autoOpen;
    },
    addOrder(order) {
      this.showAddOrder = true;
      this.editOrderMode = false;
      this.openNotifications = false;
    },
    viewTimeline() {
      this.showOrdersTimeline = true;
      this.showAddOrder = false;
      this.editOrderMode = false;
      this.openNotifications = false;
    },
    formatJustDatestamp(timestamp) {
      return moment(timestamp).format("MMM Do, YYYY");
    },
    getExpiry(duration) {
      if (duration) {
        if (duration?.indexOf("times") === -1) {
          const start = moment(new Date(), "YYYY-MM-DD").startOf("day");
          //not sure why next line is const m = moment(creation, "YYYY-MM-DD"); going to try and switch to duration
          const m = moment(duration, "YYYY-MM-DD");
          const pieces = duration.split(" ");
          m.add(pieces[0], pieces[1]).startOf("day");
          return `Expires in ${start.to(m, true)}`;
        } else return `Total of ${duration} times`;
      } else {
        return "Does Not Expire";
      }
    },
    async deleteOrder(order) {
      if (!window.confirm(`Are you sure you want to remove ${order.name}?`)) {
        return;
      }
      const response = await deleteOrderById(
        this.selectedRecord._id,
        order._id
      );
      if (response) {
        this.$store.dispatch("addNotification", {
          type: "success",
          message: `Deleted ${order.name}`,
        });
        // await this.$store.dispatch("updateRecordFromData", response[1]);
        this.$store.dispatch("updateRecordFromDB");
      } else {
        this.$store.dispatch("addNotification", {
          type: "errorMessage",
          message: `Could not delete ${order.name}`,
        });
      }
    },
    listNotifications(nArray) {
      const intro = nArray?.length ? nArray.length : "No";
      const plural = nArray?.length === 1 ? "notification" : "notifications";
      return `${intro} ${plural}`;
    },
    handletreeupdate($event) {
      if ($event) console.log($event);
    },
    convertprevnodeidstonodes() {
      this.previouslyopenednodes = [];

      for (let node of this.previouslyopenednodesid) {
        this.$store
          .dispatch("getRecordItemOnDemand", {
            recorditemid: node,
            recordid: this.selectedRecord._id,
          })
          .then((record) => {
            this.previouslyopenednodes.push(record);
          });
      }
    },
    getFrequencyString(order) {
      if (order.frequency && !(order.freq_count || order.freq_period)) {
        return order.frequency;
      }
      const count = parseInt(order.freq_count, 10);
      const period = parseInt(order.freq_period, 10);
      if (count === 1) {
        return `Once every ${this.pluralize("day", period)}`;
      }
      return `${count} times every ${this.pluralize("day", period)}`;
    },
    pluralize(word, count) {
      return `${count !== 1 ? `${count} ` : ""}${word}${
        count !== 1 ? "s" : ""
      }`;
    },
  },
  watch: {
    treeFilter: function(val, prevVal) {
      if (val === prevVal) {
        return;
      }
      if (val?.length) {
        // There is a search term so open the tree to show the matching elements
        this.$refs.treeView.updateAll(true);
      } else {
        // There is no search key so reload the tree
        this.treeViewKey++;
      }
      Vue.nextTick(() => {
        this.nodesAreHidden =
          this.$refs.treeView.excludedItems.size ===
          Object.keys(this.$refs.treeView.nodes).length;
      });
    },
    treeViewRecord: function() {
      this.convertprevnodeidstonodes();
    },
  },
};
</script>

<style lang="scss">
v-layout {
  margin: 0;
}
.v-treeview.treeClass {
  margin-left: 1.5rem;
  .v-treeview-node__checkbox {
    margin-left: 0;
  }
}

.section-container {
  width: 100%;
  margin: 10px 10px 0 0;
  display: flex;
  flex-direction: column;
  padding-left: 1.6em;

  .section {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    button {
      text-transform: none;
    }
  }
  .open {
    transform: rotate(90deg);
    transition: rotate 2s;
  }
  .cat-name::before {
    content: "●";
    margin-right: 0.5em;
    font-weight: bold;
    font-size: 1em;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.3s ease;
  }
  .fade-enter,
  .fade-leave-to {
    transform: translateX(1em);
    opacity: 0;
  }
}

.range-slider {
  .v-messages__wrapper {
    margin-top: 5px;
  }
  .v-slider__tick-label {
    font-size: 0.8em;
  }
  .v-slider--horizontal {
    margin-left: 0;
  }
}
.section-header {
  font-weight: 400;
  text-transform: none;
  color: rgba(0, 0, 0, 0.6);
}
.progress-bar {
  width: 90%;
  margin-left: 1rem;
}
</style>
